import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import { selectCommentsEnabled, selectEmojiEnabled } from 'selectors/video';
import {
  selectAnimateReactions,
  selectLocalReactions,
  selectPlayerTime,
  selectVideoDuration,
  selectVideoReactions,
} from 'selectors/videoPlayer';

import CommentTimeline from '../../control-bar/comment-timeline';
import EmojiTimeline from '../../control-bar/seek-bar/emoji-timeline';

import styles from './styles.module.less';

const PlayScreenTimeline = () => {
  const reactions = useSelector(selectVideoReactions);
  const localReactions = useSelector(selectLocalReactions);
  const duration = useSelector(selectVideoDuration);
  const currentTime = useSelector(selectPlayerTime);
  const animateReactions = useSelector(selectAnimateReactions);

  // TODO: Vlad: since duration starts as an int, we can maybe use audioDuration to prevent the jump of timeline elements.
  // const audioDuration = useSelector(selectAudioDuration);
  // const durationToUse = audioDuration || duration;

  const commentsEnabled = useSelector(selectCommentsEnabled);
  const emojiEnabled = useSelector(selectEmojiEnabled);

  const containerRef = useRef(null);

  const containerDimensions = {
    width: containerRef.current?.width || 0,
    x: 0,
  };

  return (
    <div className={styles.timelineContainer} ref={containerRef}>
      {commentsEnabled && (
        <CommentTimeline
          timelineIconClass={styles.reaction}
          duration={duration}
          suppressActiveBubble={true}
        ></CommentTimeline>
      )}

      {emojiEnabled && (
        <EmojiTimeline
          timelineIconClass={styles.reaction}
          reactions={reactions}
          localReactions={localReactions}
          controlBarExpanded={true}
          containerDimensions={containerDimensions}
          animateReactions={animateReactions}
          currentTime={currentTime}
          duration={duration}
        />
      )}
    </div>
  );
};

export default PlayScreenTimeline;
